module.exports = __webpack_public_path__ + "img/vai_logo_invert_valve_white.d0e16fc5.png";